import DynamicTable from "@/components/DynamicTable";
import MyUpload from "@/components/upload";
import { imageUrl } from "@/utils/image-url";
import { Input } from "antd";
import React from "react";

export interface ProductCategory {
  id: number;
  name: string;
  icon_url: string;
  icon_media: number;
  sort: number;
}

const ManagePromotions: React.FC = () => {
  // 上传文件变化处理
  const handleUploadChange = (info: any) => {
    console.log(0, info);
  };

  const columns = [
    {
      title: "排序",
      dataIndex: "sort",
      key: "sort",
    },
    {
      title: "名称",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "图标URL",
      dataIndex: "icon_url",
      key: "icon_url",
    },
    {
      title: "上传图标",
      dataIndex: ["media", "url"],
      key: "icon_media",
      render: (iconMedia: string) => (
        <img
          src={
            iconMedia ? imageUrl(iconMedia) : "https://via.placeholder.com/50"
          }
          alt="icon"
          style={{ width: 50, height: 50 }}
        />
      ),
    },
  ];

  const formItems = [
    {
      name: "name",
      label: "名称",
      rules: [{ required: true, message: "请输入名称!" }],
      component: <Input />,
    },
    {
      name: "icon_url",
      label: "图标图片地址",
      component: <Input />,
    },
    {
      name: "icon_media",
      label: "上传图标图片",
      render: (value: any) => (
        <MyUpload medias={[value?.media]} onChange={handleUploadChange} />
      ),
    },
  ];

  return (
    <DynamicTable
      columns={columns}
      dataSourceUrl="/product-categories"
      createUrl="/product-categories"
      updateUrl="/product-categories/media"
      deleteUrl="/product-categories"
      formItems={formItems}
      title="分类"
      sortable={true}
    />
  );
};

export default ManagePromotions;
